module.exports = __webpack_public_path__ + "static/media/54.1e8f7513.jpg";